module.exports = __webpack_public_path__ + "img/01.edc765cf.png";